import {Redirect, Route} from "react-router-dom";

let token = localStorage.getItem('token') || null;

const PublicRoute = ({component: Component, ...rest}) => {
    // console.log('PublicRoute', token);
    return (
        <Route {...rest}>{token ? <Redirect to="/"/> : <Component/>}</Route>
    );
};

export default PublicRoute;
